
import { Vue, Component } from "vue-property-decorator";

@Component
export default class extends Vue {
  mounted() {
    this.$el.querySelectorAll(".level1").forEach($el => {
      const label = $el.querySelector(".level1_label");
      const children = $el.querySelector(".level1_children");
      if (label && children) {
        label.addEventListener("click", () => {
          label.parentElement!.classList.toggle("opened");
        });
      }
    });
  }
}
